import React, { useState } from "react";
import { Modal } from "antd";
import image01 from "../../assets/images/Ellipse 1.png";
import image02 from "../../assets/images/i m student.png";
// import image03 from "../../assets/images/Facebook.png";
import { toast } from "react-toastify";
import { googleSignUp, signIn } from "../../services/auth";
import {
  AUTH_TOKEN,
  STUDENT_HOME_URL,
  STUDENT_ROLE,
  STUENT_JOURNEY_URL,
  TEACHER_JOURNEY_URL,
  TEACHER_ROLE,
} from "../../constants";
import Loader from "../loader";
import { useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
// import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { useDispatch } from "react-redux";
import { setUser } from "../../redux/slice/auth/authSlice";
import jwt_decode from "jwt-decode";
import "./styles.css";
import { fetchTeacherDocuments } from "../../services/teacher";
import { GoEyeClosed } from "react-icons/go";
import { FiEye } from "react-icons/fi";

const INITIAL_STATE = {
  email: "",
  password: "",
  role: "",
};
const SignIn = ({ openLogIn, handleLogInModal }) => {
  // const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [isTeacher, setIsTeacher] = useState(true);
  const [openSignUpModal, setOpenSignUpModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ ...INITIAL_STATE });
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleOk = () => {
    setFormData({ ...INITIAL_STATE });
    handleLogInModal(false);
  };

  const handleCancel = () => {
    setFormData({ ...INITIAL_STATE });
    handleLogInModal(false);
  };

  const handleSelection = () => {
    setIsTeacher(!isTeacher);
  };

  const handleSignUpModal = (status) => {
    setOpenSignUpModal(status);
  };

  const handleOpenSignUpModal = () => {
    setOpenSignUpModal(true);
    handleLogInModal(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      let payload = {
        ...formData,
        role: isTeacher ? TEACHER_ROLE : STUDENT_ROLE,
      };
      const { status, data } = await signIn(payload);
      if (status === 200) {
        let user = jwt_decode(data.data);
        handleLogInModal(false);
        setFormData({ ...INITIAL_STATE });
        // window.location.reload();
        // window.history.push(HOME_URL);
        localStorage.setItem(AUTH_TOKEN, data.data);

        dispatch(setUser(user));
        navigate(
          user?.role === TEACHER_ROLE ? TEACHER_JOURNEY_URL : STUDENT_HOME_URL
        );
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async (res) => {
      try {
        let payload = {
          token: res?.access_token,
          role: isTeacher ? TEACHER_ROLE : STUDENT_ROLE,
        };
        const { status, data } = await googleSignUp(payload);
        if (status === 201) {
          handleLogInModal(false);
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    onError: (res) => {
      console.log("error", res);
    },
  });

  // const facebookLogin = (response) => {
  //   console.log(response);
  // };

  return (
    <>
      {/* Button Code Start */}
      <div className="d-md-block text-center py-4">
        <button
          onClick={() => handleSelection()}
          className={`btn mb-3 mx-4 shadow-sm px-5  ${
            isTeacher ? "btn-primary primary_bg_color" : ""
          }`}
          type="button"
        >
          <img
            className="signUpTeacher mx-2"
            src={image01}
            alt="Icon"
            width="28px"
          />{" "}
          I'm a Teacher
        </button>
        <button
          onClick={() => handleSelection()}
          className={`btn ${
            !isTeacher ? "btn-primary primary_bg_color" : ""
          } shadow-sm mb-3 px-5`}
          type="button"
        >
          <img
            className="signUpStudent mx-2"
            src={image02}
            alt="Icon"
            width="28px"
          />{" "}
          I'm a Student
        </button>
      </div>
      {/* Button Code Ends */}

      {/* Form Code Start */}
      <div className="teacherSignUp">
        <h4 className="fw-bold text-center">
          Hey, {isTeacher ? "Teacher" : "Student"}
        </h4>
        <p className="signUp text-center fs_12">
          Enter the information you entered while registering
        </p>
        <form onSubmit={handleSubmit} className="mx-auto col-md-7 col-sm-6">
          <div className="mb-3">
            <label
              htmlFor="exampleInputEmail1"
              className="form-label fs_12 fw-bold"
            >
              Email address *
            </label>
            <input
              type="email"
              className="form-control"
              id="email"
              aria-describedby="emailHelp"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-labe fs_12l fw-bold">
              Password *
            </label>
            <div className="d-flex position-relative">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />

              <span className="password-toggle position-absolute">
                {showPassword ? (
                  <FiEye onClick={toggleShowPassword} />
                ) : (
                  <GoEyeClosed onClick={toggleShowPassword} />
                )}
              </span>
            </div>
            {/* <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={toggleShowPassword}
            >
              {showPassword ? "Hide" : "Show"}
            </button> */}
          </div>
          <div className="mb-3 form-check">
            {/* <input
                type="checkbox"
                className="form-check-input my-1"
                id="exampleCheck1"
              /> */}
            <div className="d-flex justify-content-end ">
              {/* <label
                  className="form-check-label fs_12 my-1"
                  htmlFor="exampleCheck1"
                >
                  Remember me
                </label> */}
              {/* <a
                  className="forgotpassword fs_12 my-1 link-dark text-decoration-none"
                  href="/"
                >
                  Forget Password
                </a> */}
            </div>
          </div>
          <button
            disabled={loading}
            type="submit"
            className="btn btn-primary btn_contained d-grid gap-2 col-12 p-2"
          >
            {loading ? <Loader /> : "Login"}
          </button>
          {/* Form Code Ends */}
          {/* Social Buttons Start */}
          {/* <GoogleLogin
              onSuccess={(credentialResponse) => {
                console.log(credentialResponse);
              }}
              onError={() => {
                console.log("Login Failed");
              }}
            /> */}
          {/* <p className="signInWith mt-4 text-center fs_12">
              {" "}
              <span className="dashed">---</span> Or Sign In With{" "}
              <span className="dashed">---</span>
            </p>

            <div className="d-md-block text-center ">
              <button
                onClick={() => googleLogin()}
                className="btn mx-4 btn-light shadow-sm px-4"
                type="button"
              >
                <img
                  className="mx-2 mb-1"
                  src={image04}
                  alt="google"
                  width="16px"
                />
                Google
              </button>
                </div> */}
          {/* <ImGoogle /> */}
          {/* <FacebookLogin
                appId="1088597931155576"
                // autoLoad
                // fields="name,email,picture"
                // scope="public_profile,user_friends,user_actions.books"
                callback={facebookLogin}
                render={(renderProps) => (
                  <button
                    onClick={renderProps.onClick}
                    className="btn mb-3 btn-light shadow px-4"
                    type="button"
                  >
                    <img
                      className="mx-2 mb-1"
                      src={image03}
                      alt="facebok"
                      width="16px"
                    />
                    Facebook
                  </button>
                )}
              /> */}
          {/* Social Buttons Ends */}
          {/* <div className="signUpText mt-3 text-center fs_12">
              <p>
                Don't have an account yet?{" "}
                <span
                  onClick={() => handleOpenSignUpModal()}
                  className="link-dark text-decoration-none fw-bold cursor_pointer"
                >
                  Sign Up
                </span>
              </p>
            </div> */}
        </form>
      </div>
    </>
  );
};

export default SignIn;
